import React from "react";
import "./SignUp.css";
import { ReactComponent as UserIcon } from "./assets/user-icon.svg";
import { ReactComponent as GoogleIcon } from "./assets/icon-google.svg";
import { useState, useEffect } from "react";
import axios from "axios";

// user-icon src

const SignUp = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    password: "",
  });

  const handleSignUp = async (event) => {
    event.preventDefault();
    console.log(formData);
    try {
      const response = await axios.post(
        "https://foodie-auth.onrender.com/auth/signup",
        formData
      );
      console.log(response.data);
      console.log("Sign up successful");
      setFormData({ name: "", email: "", password: "" });
      window.location.href = "/login";
    } catch (error) {
      console.error(error);
    }
  };

  const handleGoogleSignUp = async () => {
    window.location.href = "https://foodie-auth.onrender.com/auth/auth/google";
  };

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const token = urlParams.get("token");
    if (token) {
      // Do something with the token
      console.log(token);

      localStorage.setItem("authToken", token); // Store the token in local storage

      // Edit the URL
      const newUrl = new URL(window.location.href);
      newUrl.searchParams.delete("token");
      window.history.pushState({}, "", newUrl);
    }
  }, []);

  const handleChange = (event) => {
    setFormData({
      ...formData,
      [event.target.name]: event.target.value,
    });
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8 manual">
      <div className="max-w-md w-full space-y-8">
        <div>
          <UserIcon className="mx-auto h-16 w-auto" />
        </div>
        <form className="mt-8 space-y-6">
          <div className="rounded-md shadow-sm space-y-4">
            <div>
              <label
                htmlFor="name"
                className="block text-gray-700 font-bold mb-2"
              >
                Username
              </label>
              <input
                id="name"
                name="name"
                type="text"
                autoComplete="name"
                required
                className="appearance-none rounded-md relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 focus:outline-none focus:ring-red-600 focus:border-red-600 focus:z-10 sm:text-sm"
                placeholder="Username"
                onChange={handleChange}
              />
            </div>
            <div>
              <label
                htmlFor="email-address"
                className="block text-gray-700 font-bold mb-2"
              >
                Email address
              </label>
              <input
                id="email-address"
                name="email"
                type="email"
                autoComplete="email"
                required
                className="appearance-none rounded-md relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 focus:outline-none focus:ring-red-600 focus:border-red-600 focus:z-10 sm:text-sm"
                placeholder="Email address"
                onChange={handleChange}
              />
            </div>
            <div>
              <label
                htmlFor="password"
                className="block text-gray-700 font-bold mb-2"
              >
                Password
              </label>
              <input
                id="password"
                name="password"
                type="password"
                autoComplete="current-password"
                required
                className="appearance-none rounded-md relative block w-full px-3 py-2 border border-gray-300 placeholder-gray-500 text-gray-900 focus:outline-none focus:ring-red-600 focus:border-red-600 focus:z-10 sm:text-sm"
                placeholder="Password"
                value={formData.password}
                onChange={handleChange}
              />
            </div>
          </div>

          <div className="flex flex-col items-center justify-center mt-4 space-y-4">
            <button
              type="submit"
              onClick={handleSignUp}
              className="group relative w-36 flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 rounded-lg"
            >
              Sign up
            </button>
            <span>Or</span>
            <button
              type="button"
              onClick={handleGoogleSignUp}
              className="group relative w-full flex justify-center items-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 rounded-lg"
            >
              <GoogleIcon className="mr-4 h-7 w-7" />
              Sign in with Google
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default SignUp;
